import styled from 'styled-components';

export const Button = styled.button`
  background: ${props => props.auth ? "#262237" : "red"};
  color: ${props => props.auth ? "white" : "green"};
  font-size: 1em;
  /* margin: 1em; */
  padding: 0.25em 1em;
  border-radius: 3px;
`;